import { Card, CardMedia, Grid, Typography } from "@material-ui/core";
import "./SingleAccount.css";
import React from "react";
import logo from "../../../../../images/indian-bank/Group 14894 (1).svg";

export default function SingleAccount(props) {
  let amount;
  let accountNo;
  let customer_number;
  let account_type;

  let accountBalanceInfo = props.singleAccountData;
  // console.log("account_balance_info: ", accountBalanceInfo);

  const account_name = accountBalanceInfo[0].Body.Payload.Account_Name;
  let acc_num = accountBalanceInfo[0].Body.Payload.Account_Number;
  let account_balance = accountBalanceInfo[0].Body.Payload.Available_Balance;
  // console.log("TYPE account_balance: ", typeof account_balance);
  // let balance = Math.round(account_balance * 100) / 100;
  // console.log("account_name: ", account_name, " ", "account_balance: ", balance);

  // let balance_value = account_balance.substring(0, account_balance.indexOf(' '));
  // let transaction_type = account_balance.substring(account_balance.indexOf(' '), account_balance.length);
  // let balance = Math.round(balance_value * 100) / 100;
  // let actual_balance = balance + transaction_type;

  let balance;
  let balance_value;
  if((account_balance.indexOf(' ')>=0)){
    balance_value = account_balance.substring(0, account_balance.indexOf(' '));
    balance = parseFloat(balance_value).toFixed(2);
  } else {
    balance = parseFloat(account_balance).toFixed(2);
  }

  return (
    <div id="background"className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70" style={{ border: "8px solid rgba(244, 176, 53, 0.8)" }}>
      <Grid item xs>
        <Typography
          gutterBottom
          variant="button"
          align="center"
          component="subtitle2"
          display="block"
          style={{color: "rgba(12, 77, 162, 1)",fontWeight:600
          }}
        >
          {/* Account Balance */}
          <h5 className="single_account_card_header">Account Balance</h5>
        </Typography>
        <Grid item xs>
          <Card>
            {/* Indian Bank Logo */}
            <CardMedia component="img" image={logo} alt="ib"  style={{backgroundColor:"rgba(245, 243, 243, 1)"}}/>
          </Card>
        </Grid>
      </Grid>
      <div className="single_account_card_div">
        <Grid item>
          <Typography
            gutterBottom
            variant="h5"
            display="block"
            align="center"
            component="h2"
          >
            {/* <h6 className="single_account_card_title">₹ {actual_balance}</h6> */}
            <h6 className="single_account_card_title" style={{color:"white",paddingTop:"13px",}}>₹ {balance}</h6>
          </Typography>
        </Grid>
        <Typography
          variant="body2"
          display="block"
          align="center"
          // color="textSecondary"
          component="p"
          style={{color:"white",marginTop:"-10px",fontWeight:500}}
        >
          {/* <h6>Account Number: {accountNo}</h6> */}
          Account Number: {acc_num}
        </Typography>
        <Typography
          variant="body2"
          display="block"
          align="center"
          // color="textSecondary"
          component="p"
          style={{color:"white",fontWeight:500}}
        >
          {/* <h6>Account Number: {accountNo}</h6> */}
          Account Holder Name: {account_name}
        </Typography>
      </div>
    </div>
  );
}
